import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Country } from './country.resource';
import { Enum } from './enum.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';

@Resource({
  type: 'phoneformats',
})
export class PhoneFormat extends AtomResource {
  @Attribute() regex?: string;
  @Attribute() formatting?: string;
  @Attribute({ key: 'type' }) formatType?: string;

  @Relationship() country?: Country;
  @Relationship() enumformatting?: Enum;
  @Relationship() enumtype?: Enum;
}

export class PhoneformatConfig implements ResourceConfig {
  hosted = 'country';
  tables = {
    options: {
      copy: true,
    },
    includes: ['country', 'enumformatting', 'enumtype'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main', translatable: false }],
        header: 'ID',
        displayed: true,
      },
      {
        columnDef: 'format',
        displayedDatas: [
          {
            path: ['enumformatting.label'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Format',
        displayed: true,
      },
      {
        columnDef: 'type',
        displayedDatas: [
          {
            path: ['enumtype.label'],
            class: 'mat-body-2',
            translatable: false,
          },
        ],
        header: 'Type',
        displayed: true,
      },
      {
        columnDef: 'regex',
        displayedDatas: [
          {
            path: ['regex'],
            class: 'mat-body-1',
            translatable: false,
          },
        ],
        header: 'regex',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'developer_mode',
      title: [
        {
          path: ['enumformatting.label'],
          translatable: false,
        },
        {
          path: ['enumtype.label'],
          translatable: false,
        },
      ],
      subtitle: [
        {
          path: ['regex'],
          translatable: false,
        },
      ],
    },
  };
  wizard = {
    tabs: [
      {
        title: 'Phone Format',
        formGroup: 'phoneformat',
        list: [
          {
            type: 'enum',
            title: 'Format',
            formControl: 'formatting',
            APIKey: 'formatting',
            fieldKey: 'formatting',
            multiple: false,
            required: true,
          },
          {
            type: 'enum',
            title: 'Type',
            formControl: 'formatType',
            APIKey: 'formatType',
            fieldKey: 'type',
            multiple: false,
            required: true,
          },
          {
            type: 'text',
            title: 'Regex',
            formControl: 'regex',
            APIKey: 'regex',
            translatable: false,
            required: true,
          },
        ],
      },
    ],
  };
  resource = PhoneFormat;
  resourceName = 'Phone Format';
  resourceKey = 'phoneformats';
  includes = ['country', 'enumformatting', 'enumtype'];
  filters = [];
}
